import React, { FC, useContext } from 'react';
import interpolateContent from '../../../helpers/interpolate-content';
import { BasketDetailsType } from '../../../models/basket-details-type';
import { BasketType } from '../../../models/basket-type';
import Countdown from '../../atoms/countdown/countdown';
import { UserStateContext } from '../../providers/user/user.provider';

interface Props extends BasketDetailsType {
  readonly basket: BasketType;
}

const BasketTop: FC<Props> = ({ basket, heading, productsHeldForLabel }) => {
  const { auth } = useContext(UserStateContext);

  const sessionExpiryDate: Date | null =
    auth?.sessionExpiresAt && auth?.accessToken
      ? new Date(auth.sessionExpiresAt)
      : null;

  return (
    <div className="py-4 flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:justify-between lg:items-end">
      <div className="flex flex-col lg:flex-row items-center lg:items-end space-y-2 lg:space-y-0 lg:space-x-6">
        <h1 className="page-heading-three -mb-2">{heading}</h1>

        {sessionExpiryDate && basket?.lineItems?.length > 0 && (
          <p className="text-grey-600">
            {interpolateContent(productsHeldForLabel, '')}
            <strong className="font-semibold">
              <Countdown date={sessionExpiryDate} />
            </strong>
          </p>
        )}
      </div>

      {/* TODO: move 'Clear all' & 'Update all' buttons *HERE* */}
      <div className="flex space-x-8 justify-center items-center" />
    </div>
  );
};

export default BasketTop;
